import React, { useState } from 'react'
import QuickCreateForm from './QuickCreateForm'
import Template from 'Components/Templates/Template';
import { CLIENTTAB } from 'Constants';
import Header from 'Components/Header/Header';

function CreateCase() {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <>
        <Header />  
        
        <QuickCreateForm/>
      
     </> 
  )
}

export default CreateCase